import GoogleMapReact from 'google-map-react';
import React from 'react';
import data from '../../utils/dbSchema';
import MapMarker from './MapMarker';
import PropertiesSidebar from './PropertiesSidebar';

class SimpleMap extends React.Component {
	state = {
		zoom: 15,
	};

	_onChange = ({ center, zoom }) => {
		this.setState({
			center: center,
			zoom: zoom,
		});
	};

	render() {
		const {
			height,
			match,
			location: { city, center },
		} = this.props;
		const { properties } = data;
		return (
			// Important! Always set the container height explicitly
			<div style={{ height: height, width: '100%', position: 'relative' }}>
				<GoogleMapReact
					bootstrapURLKeys={{ key: 'AIzaSyAdsY0wBf3_4RMZ7wVycpcMSNLSmf8H4D8' }}
					center={center}
					zoom={this.state.zoom}
					onChange={this._onChange}
				>
					{properties.map((property, index) => {
						if (property.sell.digitalId > 99)
							return (
								<MapMarker
									key={index}
									lat={property.coords.lat}
									lng={property.coords.lng}
									property={property}
								/>
							);
						else return false;
					})}
				</GoogleMapReact>
				{city === 'london' && (
					<PropertiesSidebar
						properties={properties}
						match={match}
						handleFilterChange={this.handleFilterChange}
					/>
				)}
			</div>
		);
	}
}

export default SimpleMap;
